import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-green-600 text-white py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-green-100 hover:text-white mb-4 transition-colors duration-200">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Link>
          <h1 className="text-4xl font-bold">Terms and Conditions</h1>
          <p className="text-green-100 mt-2">Last updated: January 2025</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              By downloading, accessing, or using the Michango mobile application ("App"), you agree to be bound by these Terms and Conditions ("Terms"). If you do not agree to these Terms, please do not use our App.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Description of Service</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Michango App is a mobile application that facilitates group contribution management for events, trips, and celebrations. The App allows users to:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 mb-4">
              <li>Create and manage group events</li>
              <li>Collect and track contributions from group members</li>
              <li>Share contribution requests via WhatsApp Groups</li>
              <li>Provide real-time updates on contribution progress</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. User Eligibility</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              You must be at least 18 years old to use this App. By using the App, you represent and warrant that you are at least 18 years old and have the legal capacity to enter into these Terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. User Responsibilities</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              As a user of Michango, you agree to:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 mb-4">
              <li>Provide accurate and truthful information</li>
              <li>Use the App only for lawful purposes</li>
              <li>Respect other users' privacy and rights</li>
              <li>Not engage in any fraudulent or deceptive activities</li>
              <li>Maintain the security of your account credentials</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Payment Terms</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Michango App does not have any features for payments in the app but only help you to record contribution data. Only You and other users you choose can access and view your event contributions.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. WhatsApp Integration</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Our WhatsApp integration feature allows you to share contribution requests and updates with your contacts. By using this feature, you acknowledge that WhatsApp's terms of service also apply to your use of their platform through our integration.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibent text-gray-900 mb-4">7. Limitation of Liability</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Michango shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of your use of the App. Our total liability shall not exceed the amount you have paid to us in the twelve months preceding the claim.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Termination</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              We reserve the right to terminate or suspend your account and access to the App at any time, without prior notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Changes to Terms</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              We may modify these Terms at any time. We will notify users of any material changes by posting the new Terms on the App and updating the "Last updated" date. Your continued use of the App after such changes constitutes acceptance of the new Terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Contact Information</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              If you have any questions about these Terms and Conditions, please contact us at:
            </p>
            <div className="bg-green-50 p-4 rounded-lg">
              <p className="text-gray-700"><strong>Email:</strong> info@michango.app</p>
              <p className="text-gray-700"><strong>Phone:</strong> +255 741 400 600</p>
              <p className="text-gray-700"><strong>Address:</strong> Dar es Salaam, Tanzania</p>
            </div>
          </section>
        </div>

        {/* Back to Home Button */}
        <div className="mt-12 text-center">
          <Link to="/">
            <Button className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-lg">
              Back to Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
